import {
  ButtonIcon,
  FontAwesomeIcon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PendingSpinnerTooltipProps {
  tooltip: ReactNode;
  className?: string;
}

export function PendingSpinnerTooltip({ tooltip, className }: PendingSpinnerTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={className}>
          <ButtonIcon
            className="cursor-help bg-dark/5 text-dark hover:bg-dark/10"
            variant="secondary"
            icon={
              <FontAwesomeIcon
                icon="fa-light fa-loader"
                className="text-title animate-[spin_7s_linear_infinite]"
              />
            }
          />
        </div>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
